import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./slices/authSlice";
import { subscriptionReducer } from "./slices/subscriptionSlice";
import { storeReducer } from "./slices/storeSlice";
import { employeeReducer } from "./slices/employeeSlice";
import { customerReducer } from "./slices/customerSlice";
import { productReducer } from "./slices/productSlice";
import { notificationReducer } from "./slices/notificationSlice";
import { dashboardReducer } from "./slices/dashboardSlice";
import { salesReducer } from "./slices/salesSlice";
import { onboardingReducer } from "./slices/onboardingSlice";
import { superAdminAuthReducer } from "./slices/superAdminAuthSlice";

const appReducer = combineReducers({
  auth: authReducer,
  subscription: subscriptionReducer,
  stores: storeReducer,
  sales: salesReducer,
  employees: employeeReducer,
  customers: customerReducer,
  products: productReducer,
  notifications: notificationReducer,
  dashboard: dashboardReducer,
  onboarding: onboardingReducer,
  superAdminAuth: superAdminAuthReducer,
});

const rootReducer = (state: any, action: any) => {
  // 👇 When logout is dispatched, reset all state
  if (action.type === "auth/logout" || action.type === "auth/resetAuth") {
    // also clear persisted data
    localStorage.removeItem("persist:root");
    localStorage.removeItem("subscription_state_v1");
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
